import {
  useCrarCodigosSobres,
  useListarCodigosObjetos,
  useListarObjetos,
  useListarGrados,
} from "../../../../Hooks/Admin";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";

export const ObjetosCodigos = () => {
  const [campos, setCampos] = useState();
  const queryListarObjetos = useListarObjetos([]);
  const queryListarGrados = useListarGrados([]);

  useEffect(() => {
    if (queryListarObjetos.isSuccess && queryListarGrados.isSuccess) {
      setCampos(
        camposFormulario({
          objetos: queryListarObjetos.data,
          grados: queryListarGrados.data,
        })
      );
    }
  }, [queryListarObjetos.isSuccess, queryListarGrados.isSuccess]);
  return (
    <>
      {campos && (
        <CustomTable
          tituloTabla="Codigos Objetos"
          camposFilter={camposFilter}
          camposFormularioModal={campos}
          queryListar={useListarCodigosObjetos}
          formatData={formatData}
          columns={columns}
          camposAgregar={camposFormulario({
            objetos: queryListarObjetos.data,
            grados: queryListarGrados.data,
          })}
          queryCrear={useCrarCodigosSobres}
        />
      )}
    </>
  );
};
